import script from "./AdminLocationSubcategories.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLocationSubcategories.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLocationSubcategories.vue?vue&type=style&index=0&id=37e9802e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37e9802e"]])

export default __exports__